export const cardSchemesConstants = {
  GET_CARDSCHEMES_REQUEST: "GET_CARDSCHEMES_REQUEST",
  GET_CARDSCHEMES_SUCCESS: "GET_CARDSCHEMES_SUCCESS",
  GET_CARDSCHEMES_FAILURE: "GET_CARDSCHEMES_FAILURE",
  GET_CARDSCHEMES_RESET: "GET_CARDSCHEMES_RESET",

  VIEW_CARDSCHEME_REQUEST: "VIEW_CARDSCHEME_REQUEST",
  VIEW_CARDSCHEME_SUCCESS: "VIEW_CARDSCHEME_SUCCESS",
  VIEW_CARDSCHEME_FAILURE: "VIEW_CARDSCHEME_FAILURE",
  VIEW_CARDSCHEME_RESET: "VIEW_CARDSCHEME_RESET",

  ADD_CARDSCHEME_REQUEST: "ADD_CARDSCHEME_REQUEST",
  ADD_CARDSCHEME_SUCCESS: "ADD_CARDSCHEME_SUCCESS",
  ADD_CARDSCHEME_FAILURE: "ADD_CARDSCHEME_FAILURE",
  ADD_CARDSCHEME_RESET: "ADD_CARDSCHEME_RESET",

  EDIT_CARDSCHEME_REQUEST: "EDIT_CARDSCHEME_REQUEST",
  EDIT_CARDSCHEME_SUCCESS: "EDIT_CARDSCHEME_SUCCESS",
  EDIT_CARDSCHEME_FAILURE: "EDIT_CARDSCHEME_FAILURE",
};
